import { render, staticRenderFns } from "./DateInputMenu.vue?vue&type=template&id=b6c1b658"
import script from "./DateInputMenu.vue?vue&type=script&lang=ts"
export * from "./DateInputMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports